<template>
  <section />
</template>

<script>
export default {
  name: 'Home',
};
</script>
